// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

//import Rails from "@rails/ujs"
//Rails.start()
import { Application } from "@hotwired/stimulus"
const application = Application.start()

import * as ActiveStorage from "@rails/activestorage"
import { Turbo } from "@hotwired/turbo-rails"
Turbo.start();

import "channels"
import "controllers"
import flatpickr from "flatpickr"
require("flatpickr/dist/flatpickr.css")
import "chartkick"
import "chart.js"

ActiveStorage.start()

export { application }
